import { createAction } from 'redux-actions';
import { ThunkDispatch } from 'redux-thunk';

import FolderFeedbackAPI from '../FolderFeedbackAPI';
import { FolderFeedbackState } from '../FolderFeedbackStateDefinition';
import { FolderFeedbackContent, TYPES } from '../types';

export const submitFolderFeedbackStarted = createAction(
  TYPES.FOLDER_FEEDBACK_SUBMIT_STARTED
);
export const submitFolderFeedbackFailed = createAction(
  TYPES.FOLDER_FEEDBACK_SUBMIT_FAILED
);
export const submitFolderFeedbackCompleted = createAction(
  TYPES.FOLDER_FEEDBACK_SUBMIT_COMPLETED
);

export const sendFeedback = (content: FolderFeedbackContent) => {
  return async (
    dispatch: ThunkDispatch<any, any, any>,
    getState: () => { folderFeedback: FolderFeedbackState }
  ): Promise<void> => {
    dispatch(submitFolderFeedbackStarted());

    try {
      const response = await FolderFeedbackAPI.sendFeedback({
        ...content,
        uniqueId: getState().folderFeedback.uniqueId,
      });
      const json = await response.json();
      dispatch(submitFolderFeedbackCompleted(json.message));
    } catch (e) {
      dispatch(submitFolderFeedbackFailed(e.json?.message || e.message));
    }
  };
};
